var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-card d-flex justify-content-between rejected-interns"},[_c('strong',[_vm._v(_vm._s(_vm.$t('pages.offer-intern.rejected-interns.title')))]),_c('div',[_vm._v(_vm._s(_vm.rejectedInternsCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }